import { useMemo } from 'react'
import { RegisterOptions } from 'react-hook-form'
import { useGetEmployerMetaFields } from 'Hooks/api/employer/useGetEmployerMetaFields'
import { UserDetailsForEmployer } from 'Utils/types/user'

type UseUserMetadataFormParams = {
  employerId?: number
  user?: UserDetailsForEmployer
}

export const useUserMetadataForm = ({ employerId, user }: UseUserMetadataFormParams) => {
  const { data: metaFields, isLoading: isLoadingMetaFields } = useGetEmployerMetaFields(employerId)

  const defaultValues = useMemo(
    () =>
      Object.fromEntries(
        (metaFields || []).map((mf) => [`${mf.id}`, user?.metaDataHash?.[mf.fieldName] ?? ''])
      ),
    [metaFields, user?.metaDataHash]
  )

  const registerOptions: Record<string, RegisterOptions> = useMemo(
    () =>
      Object.fromEntries(
        (metaFields || []).map((mf) => [
          `${mf.id}`,
          {
            required: mf.required
          }
        ])
      ),
    [metaFields]
  )

  return {
    metaFields: metaFields || [],
    isLoadingMetaFields,
    defaultValues,
    registerOptions
  }
}
